import React from "react";

type Props = {
  sizes: string;
  image: Image;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  onLoad?: (evt: React.SyntheticEvent) => void;
};

export default function Picture(props: Props) {
  const { image, loading = "eager", fetchPriority } = props;

  const sizes = props.sizes || "100vw";

  const handleLoaded = (evt: React.SyntheticEvent) => {
    if (props.onLoad) {
      props.onLoad(evt);
    }
  };

  const imgProps: React.ImgHTMLAttributes<HTMLImageElement> & {
    fetchpriority?: "high" | "low" | "auto";
  } = {
    onLoad: handleLoaded,
    src: image.src,
    alt: image.alternative,
    srcSet: image.srcset ?? undefined,
    width: image.width,
    height: image.height,
    sizes: sizes,
    loading: loading
  };

  if (fetchPriority) {
    imgProps.fetchpriority = fetchPriority;
  }

  return (
    <picture>
      {image.sources.map((source) => (
        <source
          key={source.type}
          type={source.type}
          srcSet={source.srcset}
          sizes={sizes}
        />
      ))}
      <img {...imgProps} />
    </picture>
  );
}
